export default "__VITE_ASSET__BsqYJ8Od__"